import React from "react";

import useMediaQuery from "@material-ui/core/useMediaQuery";

interface DesktopContainerDrawerProps {
	props?: any;
	children: React.ReactNode;
}

const DesktopContainerDrawer = ({ children }: DesktopContainerDrawerProps) => {
	const matches = useMediaQuery("(min-width:481px)");

	return <>{matches ? children : null}</>;
};

DesktopContainerDrawer.minWidth = 481;

export default DesktopContainerDrawer;
